import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const HEADER_HEIGHT = 48;
const SIDE_PADDING = 8;
const MAX_HEIGHT = 763;
const DEFAULT_WIDTH = 480;

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray60,
      maxWidth: DEFAULT_WIDTH,
      zIndex: theme.zIndex.modal,
      height: '100%',
      maxHeight: `min(100% - ${SIDE_PADDING * 2}px, ${MAX_HEIGHT}px)`,
      overflowY: 'hidden',
      boxShadow: theme.shape.boxShadowExtraLarge,
    },
    backdrop: {
      zIndex: theme.zIndex.modal - 1,
    },
    header: {
      padding: theme.spacing(1, 1, 1, 2),
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: theme.shape.borderGray70,
      alignItems: 'center',
      height: HEADER_HEIGHT,
    },
    buttonClose: {
      color: COLORS.gray.gray40,
    },
    children: {
      overflowY: 'auto',
      maxHeight: `calc(100% - ${HEADER_HEIGHT}px)`,
    },
  }),
  { name: 'StylesMenu' }
);
